// @flow
import * as React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/label.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/statistic.css'
import { connect } from 'react-redux'
import './styles.scss'
import type { AppState } from '../../stores/index'
import type { RequestStatus } from './reducer'

function loadingIndicator ({
  loadingStatus
}: {
  loadingStatus: RequestStatus
}): null | React.Element<'div'> {
  switch (loadingStatus) {
    case 'loading':
      return (
        <div className='ui green large label loading indicator'>
          <i className='circle notched loading icon' />
          Chargement ...
        </div>
      )

    case 'success':
      return null

    case 'error':
      return (
        <div className='ui red large label loading indicator'>
          <i className='warning sign icon' />
          Une erreur est survenue
        </div>
      )
  }
}

function mapStateToProps ({ requestStatus }: AppState) {
  return {
    loadingStatus: requestStatus
  }
}

export const LoadingIndicator = connect(mapStateToProps, null)(loadingIndicator)

export default LoadingIndicator



// WEBPACK FOOTER //
// ./src/components/loadingIndicator/index.js